var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text"},domProps:{"value":_vm.viewValue},on:{"input":_vm.onInput,"keydown":_vm.onKeydown,"blur":_vm.onBlur,"focus":_vm.onFocus}})}
var staticRenderFns = []

export { render, staticRenderFns }